import { SportIconId } from 'libs/icons2/types';
import { IconsMap, iconsMap } from '../../components/Icon/icons';

export const getSportIcon = (sportId: SportIconId) => {
  const sportIconName = `icons/sport/id-${sportId}` as keyof IconsMap;
  const defaultIconName = 'icons/sport/default';

  return iconsMap[sportIconName] ? sportIconName : defaultIconName;
};
